import { Badge } from "@/components/ui/badge";

const STATUS_STYLES = {
  "Aktif Çalışıyor": "bg-emerald-100 text-emerald-800 border border-emerald-200",
  "Arızalı": "bg-red-100 text-red-800 border border-red-200",
  "Bakımda": "bg-amber-100 text-amber-800 border border-amber-200",
  "Boşta-Atıl": "bg-zinc-200 text-zinc-700 border border-zinc-300",
};

export const MACHINE_STATUSES = ["Aktif Çalışıyor", "Arızalı", "Bakımda", "Boşta-Atıl"];

export function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || STATUS_STYLES["Boşta-Atıl"];
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-bold ${cls}`}
    >
      {status}
    </span>
  );
}

export function StockBadge({ critical }) {
  return (
    <span
      className={`inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-bold ${
        critical
          ? "bg-red-100 text-red-800 border border-red-200"
          : "bg-emerald-100 text-emerald-800 border border-emerald-200"
      }`}
    >
      {critical ? "⚠️ KRİTİK" : "Yeterli"}
    </span>
  );
}

export function ExpiryBadge({ expiries }) {
  const items = (expiries || []).filter((e) => e.status === "soon" || e.status === "overdue");
  if (items.length === 0) return <span className="text-xs text-muted-foreground">—</span>;
  const short = { "Muayene": "Muayene", "Trafik Sigortası": "Sigorta", "Kasko": "Kasko", "Egzoz Ölçümü": "Egzoz" };
  return (
    <div className="flex flex-col gap-1">
      {items.map((e) => {
        const overdue = e.status === "overdue";
        const cls = overdue
          ? "bg-red-100 text-red-800 border border-red-200"
          : "bg-amber-100 text-amber-800 border border-amber-200";
        const label = overdue
          ? `${short[e.label] || e.label}: ${Math.abs(e.days_left)}g geçti`
          : `${short[e.label] || e.label}: ${e.days_left}g kaldı`;
        return (
          <span key={e.field} data-testid={`expiry-badge-${e.field}`} className={`inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-bold w-fit ${cls}`}>{label}</span>
        );
      })}
    </div>
  );
}

export function ReminderBadge({ status, remaining, unit }) {
  if (!status || status === "none") {
    return <span className="text-xs text-muted-foreground">—</span>;
  }
  if (status === "ok") {
    return <span className="text-xs text-muted-foreground">{remaining != null ? `${remaining} ${unit || ""} kaldı` : "Takipte"}</span>;
  }
  const overdue = status === "overdue";
  const cls = overdue
    ? "bg-red-100 text-red-800 border border-red-200"
    : "bg-amber-100 text-amber-800 border border-amber-200";
  const label = overdue
    ? `Gecikti (${Math.abs(remaining)} ${unit || ""} aşıldı)`
    : `Yaklaşıyor (${remaining} ${unit || ""})`;
  return <span className={`inline-flex items-center rounded-sm px-2 py-0.5 text-xs font-bold ${cls}`}>{label}</span>;
}
